import React from "react";
import styles from './styles.module.scss';

export const IntegrationSectionVideo = ({ url }) => {

  return (
    <div className={styles.videoContainer}>
      <iframe 
      src={url} frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  );
};
